if (!process.env["NEXT_PUBLIC_HOST"])
	throw new Error("NEXT_PUBLIC_HOST is not defined");

/**
 *
 * @param path
 * @returns
 */
export const makeUrl = (path: string): URL =>
	new URL(path, process.env["NEXT_PUBLIC_HOST"]);
